import UIIllustration from 'UIComponents/image/UIIllustration';
import UIFlex from 'UIComponents/layout/UIFlex';
import { OLAF, GREAT_WHITE } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import PageHeading from 'UIComponents/elements/headings/PageHeading';
import UIStatusDot from 'UIComponents/tag/UIStatusDot';
import Small from 'UIComponents/elements/Small';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TOOLBAR_HEIGHT = 60;
const EmptyThreadToolbar = styled.div.withConfig({
  displayName: "ViewProgressState__EmptyThreadToolbar",
  componentId: "qaiww-0"
})(["height:", "px;background-color:", ";border-bottom:solid 1px ", ";"], TOOLBAR_HEIGHT, OLAF, GREAT_WHITE);
function ViewProgressState({
  showEmptyThreadToolbar = true
}) {
  return /*#__PURE__*/_jsxs("div", {
    className: "width-100",
    children: [showEmptyThreadToolbar && /*#__PURE__*/_jsx(EmptyThreadToolbar, {}), /*#__PURE__*/_jsxs(UIFlex, {
      className: "m-top-15 p-x-10 width-100",
      justify: "start",
      align: "center",
      direction: "column",
      children: [/*#__PURE__*/_jsx(UIIllustration, {
        name: "building",
        width: "200px",
        "data-test-id": "view-progress-state"
      }), /*#__PURE__*/_jsx(PageHeading, {
        className: "m-y-4",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "svh-workspace-ui-lib.custom-views.progressStates.building.title"
        })
      }), /*#__PURE__*/_jsx("p", {
        className: "text-center",
        style: {
          maxWidth: '540px'
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "svh-workspace-ui-lib.custom-views.progressStates.building.paragraph"
        })
      }), /*#__PURE__*/_jsxs(Small, {
        className: "align-center",
        children: [/*#__PURE__*/_jsx(UIStatusDot, {
          use: "warning"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "svh-workspace-ui-lib.custom-views.progressStates.building.progress"
        })]
      })]
    })]
  });
}
ViewProgressState.displayName = 'ViewProgressState';
export default ViewProgressState;